import { CollapsibleCard } from '@myphx-engineering/phx-design-system';

import type { DigitallyReceivedPrescriberOrderInfoFragment } from '../../../graphql/generated/graphql';

import PatientMedicationDetailsHeader from './PatientMedicationDetailsHeader';
import PrescriberOrderDetails from './PrescriberOrderDetails';

export type PatientMedicationDetailsProps = {
    patientName: string;
    prescriberOrder: DigitallyReceivedPrescriberOrderInfoFragment;
};

// TODO: consider moving into rx-common or myphx-lib, dupe of PatientProductDetailsV2 in my-prescryptive
const PatientMedicationDetails = ({
    patientName,
    prescriberOrder,
}: PatientMedicationDetailsProps) => {
    return (
        <CollapsibleCard
            variant="elevated"
            header={
                <PatientMedicationDetailsHeader
                    patientName={patientName}
                    prescriberOrder={prescriberOrder}
                />
            }
        >
            <PrescriberOrderDetails prescriberOrder={prescriberOrder} />
        </CollapsibleCard>
    );
};

export default PatientMedicationDetails;
